import axios from 'axios';

// API Axios Get Call.
export const getAPICall = (url, data) => {
    return axios.get(url, {
        params: data
    }, {
        withCredentials: false,
    });
}

export const getAPICallBlob = (url, data) => {
    return axios.get(url, {
        params: data,
        withCredentials: false,
        responseType: 'blob',
    });
}
// API Axios Post Call.
export const postAPICall = (url, data, isFormData) => {
    return axios.post(url, data, {
        withCredentials: false,
    });
}

export const postAPICallV2 = (url, data) => {
    const payload = data instanceof FormData ? data : data;

    return axios.post(url, payload, {
        withCredentials: false,
        headers: payload instanceof FormData
            ? { 'Content-Type': 'multipart/form-data' }
            : { 'Content-Type': 'application/json' }
    });
};

export const toFormData = (obj) => {
    const fd = new FormData();

    Object.keys(obj).forEach(key => {
        const value = obj[key];

        if (Array.isArray(value)) {
            // append each entry separately
            value.forEach(v => fd.append(key + '[]', v));
        } else {
            fd.append(key, value);
        }
    });

    return fd;
};

export const postAPICallParams = (url, data) => {
    return axios.post(url, {
        params: data
    }, {
        withCredentials: false,
    });
}
// API Axios Put Call.
export const putAPICall = (url, data) => {
    return axios.put(url, data, {
        withCredentials: false,
    });
}
// API Axios Delete Call.
export const deleteAPICall = (url) => {
    return axios.delete(url, {
        withCredentials: false,
    });
}